import React from "react";

function MobileMenu(props) {

    return (
        <div id="mobile-menu-trigger-wrapper" className="flex">
            <div>
                <div onClick={props.menuClicked} className="mobileMainMenuToggle">
                    <span className="mobile-menu-icon mobile-menu-icon--menu"/>
                    <span>Menu</span>
                </div>
            </div>
            <div>
                <div onClick={props.searchClicked} className="mobileMainMenuToggle">
                    <span className="mobile-menu-icon mobile-menu-icon--search"/>
                    <span>Szukaj auta</span>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;